/* ── Bara Bros Coupon Popup — bb-coupon-popup.js ── */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var cfg = window.BB_COUPON_POPUP_CFG;
  if (!cfg || !cfg.enabled) return;

  var DEBUG = window.location.search.indexOf('debugRewards=1') !== -1;

  var DISMISS_KEY    = 'bb_coupon_popup_dismissed';
  var SESSION_KEY    = 'bb_coupon_popup_seen_session';
  var HIDE_TODAY_KEY = 'bb_coupon_popup_hide_today';
  var PENDING_KEY    = 'bb_pending_coupon_claim';

  var state = {
    campaigns:          [],
    claimedIds:         new Set(),
    usedIds:            new Set(),
    loaded:             false,
    claiming:           false,
    personalizedRewards: null
  };

  /* Fetch deduplication */
  var _fetchCallbacks = [];
  var _fetching       = false;
  var _fetchError     = false;

  /* DOM refs (assigned in init) */
  var overlay, modal, closeBtn, hideTodayBtn, cardsEl, collectBtn, walletLink, toastEl, headingEl, bottomNoteEl;

  /* Automatic campaigns and the cart (bb-overlay-coordinator.js): never on
     the cart page; elsewhere they wait while the shopper is using the cart
     (drawer, cart tools, summary sheet, checkout starting) and open a few
     seconds after it is closed; if the cart opens over one, it steps aside
     and comes back the same way. Waiting or stepping aside never counts as a
     dismissal or as this session's showing. "View Available Coupons" (a
     shopper's own tap) always opens at once. */
  var AUTO_QUIET_MS = 3000;
  var autoOpened = false;
  var cancelAutoWait = null;

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Init ── */
  function init() {
    overlay      = document.getElementById('bb-coupon-popup-overlay');
    if (!overlay) return;
    modal        = document.getElementById('bb-cp-modal');
    closeBtn     = document.getElementById('bb-cp-close');
    hideTodayBtn = document.getElementById('bb-cp-btn-hide-today');
    cardsEl      = document.getElementById('bb-cp-cards');
    collectBtn   = document.getElementById('bb-cp-btn-collect');
    walletLink   = document.getElementById('bb-cp-link-wallet');
    toastEl      = document.getElementById('bb-cp-toast');
    headingEl    = document.getElementById('bb-cp-heading');
    bottomNoteEl = document.getElementById('bb-cp-bottom-note');

    /* Apply desktop 2-col class once at init */
    if (window.innerWidth > 600 && cfg.desktopCouponColumns === 2 && cardsEl) {
      cardsEl.classList.add('bb-cp-cards--two-col');
    }

    closeBtn.addEventListener('click', dismiss);
    overlay.addEventListener('click', function (e) { if (cfg.clickOverlayToClose !== false && e.target === overlay) dismiss(); });
    /* Escape closes the popup only when it is open (Escape on the cart used
       to record a coupon dismissal for a popup nobody had seen). */
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-visible')) dismiss(); });

    /* The cart opened over an automatic campaign: step aside. */
    document.addEventListener('bb:overlay:change', function (e) {
      var d = e.detail || {};
      if (!d.open || String(d.id).indexOf('cart:') !== 0 || d.id === 'cart:coupons') return;
      if (autoOpened && overlay.classList.contains('is-visible')) yieldToCart();
    });
    collectBtn.addEventListener('click', handleCollect);

    if (hideTodayBtn) {
      if (cfg.enableHideToday) {
        hideTodayBtn.style.display = '';
        hideTodayBtn.addEventListener('click', dismissToday);
      }
    }

    /* Manual trigger links: <a href="/pages/coupons" data-bb-open-coupon-popup> */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-bb-open-coupon-popup]');
      if (trigger) { e.preventDefault(); openManually(); }
    });

    /* Silently resolve any pending post-login claim */
    if (cfg.loggedIn) tryResolvePendingClaim();

    /* Auto-show after delay if page and state conditions pass */
    if (!shouldExcludePage() && shouldAutoShow()) {
      setTimeout(autoShow, (cfg.showDelay || 0) * 1000);
    }
  }

  function isCartPage() {
    var path = window.location.pathname.replace(/\/$/, '');
    return document.body.classList.contains('template-cart') || path === '/cart' || /\/cart$/.test(path);
  }

  /* ── Page exclusion ── */
  function shouldExcludePage() {
    var path = window.location.pathname;
    /* Automatic campaigns never open on the cart page. */
    if (isCartPage()) return true;
    /* Always skip checkout and auth pages */
    if (path.indexOf('/checkout') === 0) return true;
    if (path === '/account/login' || path === '/account/register') return true;
    /* Configurable exclusions */
    if (cfg.hideOnCouponPage   && path.indexOf('/pages/coupons') === 0) return true;
    if (cfg.hideOnCartPage     && path === '/cart') return true;
    if (cfg.hideOnAccountPages && path.indexOf('/account') === 0) return true;
    if (cfg.hideOnProductPages && path.indexOf('/products/') !== -1) return true;
    if (cfg.showOnHomepageOnly && path !== '/') return true;
    return false;
  }

  /* ── Should auto-show? ── */
  function shouldAutoShow() {
    try {
      var d = JSON.parse(localStorage.getItem(DISMISS_KEY));
      if (d && Date.now() < d.until) return false;
    } catch (e) {}
    try {
      var t = parseInt(localStorage.getItem(HIDE_TODAY_KEY), 10);
      if (t && Date.now() < t) return false;
    } catch (e) {}
    try { if (sessionStorage.getItem(SESSION_KEY)) return false; } catch (e) {}
    return true;
  }

  /* ── Auto-show: fetch first, only open if there's something to collect ── */
  function autoShow() {
    fetchPageData(function (data) {
      if (!data || !data.ok) {
        if (DEBUG) console.log('[BB Popup][debugRewards] autoShow suppressed — data null or ok=false:', data ? data.error : 'null response');
        return;
      }

      var campaigns  = (data.campaigns || []).slice(0, cfg.maxCampaigns || 4);
      if (!campaigns.length) {
        if (DEBUG) console.log('[BB Popup][debugRewards] autoShow suppressed — 0 campaigns in page-data (raw campaigns:', (data.campaigns || []).length, ')');
        return;
      }

      var claimedIds = buildClaimedSet(data);
      var usedIds    = buildUsedSet(data);
      var allClaimed = campaigns.every(function (c) { return claimedIds.has(String(c.id)); });
      if (allClaimed) {
        if (DEBUG) console.log('[BB Popup][debugRewards] autoShow suppressed — all', campaigns.length, 'campaign(s) already claimed');
        return; /* Nothing new to offer */
      }

      state.campaigns          = campaigns;
      state.claimedIds         = claimedIds;
      state.usedIds            = usedIds;
      state.personalizedRewards = (data && data.personalized_rewards) || null;
      state.loaded             = true;

      openAutoWhenCartIdle();
    });
  }

  function openAutoWhenCartIdle() {
    var O = window.BBOverlay;
    if (cancelAutoWait) cancelAutoWait();
    cancelAutoWait = null;
    if (O && O.cartBusy()) {
      cancelAutoWait = O.whenCartIdle(function () {
        cancelAutoWait = null;
        openAutoNow();
      }, AUTO_QUIET_MS);
      return;
    }
    openAutoNow();
  }

  function openAutoNow() {
    /* Re-checked: dismissed, opened by the shopper, or now on the cart page. */
    if (overlay.classList.contains('is-visible') || !shouldAutoShow() || isCartPage()) return;
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    updateHeading();
    renderCards();
    updateCollectBtn();
    updateBottomNote();
    autoOpened = true;
    openOverlay();
  }

  function yieldToCart() {
    autoOpened = false;
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    pageUnlock();
    /* Not seen to the end: this session's showing is not used up. */
    try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
    openAutoWhenCartIdle();
  }

  /* ── Manual open: bypasses dismiss/session/page checks ── */
  function openManually() {
    autoOpened = false;
    if (cancelAutoWait) cancelAutoWait();
    cancelAutoWait = null;
    if (state.loaded) {
      updateHeading();
      openOverlay();
      return;
    }
    openOverlay(); /* Show loading skeleton immediately */
    fetchPageData(function (data) {
      var campaigns  = [];
      var claimedIds = new Set();
      var usedIds    = new Set();
      if (data && data.ok) {
        campaigns  = (data.campaigns || []).slice(0, cfg.maxCampaigns || 4);
        claimedIds = buildClaimedSet(data);
        usedIds    = buildUsedSet(data);
      }
      if (DEBUG) {
        var walletCoupons = (data && data.wallet && Array.isArray(data.wallet.coupons)) ? data.wallet.coupons.length : 0;
        var unclaimed     = campaigns.filter(function (c) { return !claimedIds.has(String(c.id)) && !usedIds.has(String(c.id)); });
        console.log('[BB Popup][debugRewards] openManually fetch complete —',
          'data.ok:', data ? data.ok : false,
          '| logged_in:', data ? data.logged_in : false,
          '| raw campaigns:', data ? (data.campaigns || []).length : 0,
          '| capped campaigns:', campaigns.length,
          '| wallet coupons:', walletCoupons,
          '| unclaimed:', unclaimed.length,
          '| fetch_error:', _fetchError
        );
        if (!data || !data.ok) console.warn('[BB Popup][debugRewards] page-data error:', data ? data.error : 'null');
        if (campaigns.length === 0) console.warn('[BB Popup][debugRewards] "No coupons available" — reason: campaigns array empty from endpoint');
      }
      state.campaigns          = campaigns;
      state.claimedIds         = claimedIds;
      state.usedIds            = usedIds;
      state.personalizedRewards = (data && data.personalized_rewards) || null;
      state.loaded             = true;
      updateHeading();
      renderCards();
      updateCollectBtn();
      updateBottomNote();
    });
  }

  /* ── Fetch page-data (deduplicated: concurrent callers share one request) ── */
  function fetchPageData(cb) {
    _fetchCallbacks.push(cb);
    if (_fetching) return;
    _fetching = true;

    var ctrl  = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, 8000);

    fetch(cfg.pageDataUrl, { signal: ctrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        clearTimeout(timer);
        _fetching = false;
        if (DEBUG) {
          console.log('[BB Popup][debugRewards] ── page-data raw response ──');
          console.log('[BB Popup][debugRewards] endpoint:', cfg.pageDataUrl);
          console.log('[BB Popup][debugRewards] ok:', d && d.ok, '| logged_in:', d && d.logged_in);
          console.log('[BB Popup][debugRewards] campaigns:', d && d.campaigns ? d.campaigns.length : 0,
            '| wallet_coupons:', d && d.wallet && d.wallet.coupons ? d.wallet.coupons.length : 0);
          if (d && d.campaigns && d.campaigns.length) {
            console.log('[BB Popup][debugRewards] campaign IDs:', d.campaigns.map(function(c){ return c.id + '(' + c.title + ')'; }).join(', '));
          }
          if (!d || !d.ok) console.warn('[BB Popup][debugRewards] page-data returned not-ok:', d ? JSON.stringify(d).slice(0, 300) : 'null');
        }
        flushCbs(d);
      })
      .catch(function (err) {
        clearTimeout(timer);
        _fetching    = false;
        _fetchError  = true;
        if (DEBUG) console.warn('[BB Popup][debugRewards] page-data fetch threw:', err && err.message ? err.message : String(err));
        flushCbs(null);
      });
  }

  function flushCbs(d) {
    var cbs = _fetchCallbacks.splice(0);
    cbs.forEach(function (fn) { try { fn(d); } catch (e) {} });
  }

  /* ── Build set of campaign IDs already in wallet ── */
  function buildClaimedSet(data) {
    var s       = new Set();
    var coupons = (data.wallet && Array.isArray(data.wallet.coupons)) ? data.wallet.coupons : [];
    coupons.forEach(function (c) { s.add(String(c.id)); });
    return s;
  }

  /* ── Build set of campaign IDs that have been used ── */
  function buildUsedSet(data) {
    var s       = new Set();
    var coupons = (data.wallet && Array.isArray(data.wallet.coupons)) ? data.wallet.coupons : [];
    coupons.forEach(function (c) {
      if (c.status === 'used' || c.used === true) s.add(String(c.id));
    });
    return s;
  }

  /* ── Update heading based on login + claim state + personalization ── */
  function updateHeading() {
    if (!headingEl) return;
    if (!cfg.loggedIn) {
      headingEl.textContent = cfg.headingLoggedOut || 'Unlock Your Bara Bros Coupons';
      return;
    }
    var unclaimed = state.campaigns.filter(function (c) {
      return !state.claimedIds.has(String(c.id));
    });
    if (state.campaigns.length && !unclaimed.length) {
      headingEl.textContent = cfg.headingAllSaved || 'Your Coupons Are Ready';
      return;
    }
    /* Use personalized primary message for expiring/points nudge priorities */
    var pr = state.personalizedRewards;
    if (pr && pr.primary_message && pr.priority && pr.priority !== 'logged_in_no_coupons') {
      headingEl.textContent = pr.primary_message;
      return;
    }
    headingEl.textContent = cfg.headingLoggedIn || 'Collect Your Coupons';
  }

  /* ── Show/update bottom note ── */
  function updateBottomNote() {
    if (!bottomNoteEl) return;
    if (!cfg.showBottomNote) { bottomNoteEl.style.display = 'none'; return; }
    var text = cfg.loggedIn
      ? (cfg.bottomNoteLoggedIn  || '')
      : (cfg.bottomNoteLoggedOut || '');
    if (text) {
      bottomNoteEl.textContent = text;
      bottomNoteEl.style.display = '';
    } else {
      bottomNoteEl.style.display = 'none';
    }
  }

  /* ── Clean customer-facing coupon label (strips backend source language) ── */
  function cleanCouponDisplay(c) {
    var lblCfg       = window.BB_COUPON_LABELS_CFG || {};
    var productLabel = lblCfg.productCouponLabel  || 'Limited-Time Product Coupon';
    var refMode      = lblCfg.productRefDisplay   || 'product_name';
    var maxLen       = lblCfg.productNameMaxLength || 40;
    var showLink     = lblCfg.showProductLink      !== false;
    var linkText     = lblCfg.productLinkText      || 'View eligible product';

    var title    = String(c.title    || 'Coupon');
    var subtitle = String(c.subtitle || '');

    var isBackend = /\bscheduler\b/i.test(subtitle) || /product.targeted coupon for/i.test(subtitle);
    var isProduct = (c.applies_to && c.applies_to.type === 'products')
      || c.source === 'scheduler' || c.source === 'manual_product';

    if (isProduct && isBackend) subtitle = productLabel;

    var handle = '', pTitle = '', refText = '', linkLabel = '';
    if (isProduct) {
      var handles = (c.applies_to && c.applies_to.product_handles) || [];
      var ptitles = (c.applies_to && c.applies_to.product_titles)  || [];
      handle = String(handles[0] || c.product_handle || '');
      pTitle = String(ptitles[0] || c.product_title  || '');
      var dname = pTitle || handle;
      if      (refMode === 'product_name'          && dname)  refText = 'Eligible for ' + dname;
      else if (refMode === 'product_name_ellipsis' && dname)  refText = 'Eligible for ' + (dname.length > maxLen ? dname.slice(0, maxLen) + '…' : dname);
      else if (refMode === 'product_slug'          && handle) refText = 'Eligible product: ' + handle;
      else if (refMode === 'generic')                         refText = 'Eligible product only';
      if (showLink && handle) {
        linkLabel = linkText === 'product_name'   ? (pTitle || handle)
                  : linkText === 'product_handle' ? handle
                  : linkText;
      }
    }
    return { title: title, subtitle: subtitle, refText: refText, handle: handle, linkLabel: linkLabel };
  }

  /* ── Render coupon cards ── */
  function renderCards() {
    if (!cardsEl) return;
    if (_fetchError) {
      if (DEBUG) console.warn('[BB Popup][debugRewards] renderCards: fetch error — showing error empty state');
      cardsEl.innerHTML = '<p class="bb-cp-empty bb-cp-empty--error">Coupons could not load. Please try again.</p>';
      return;
    }
    if (!state.campaigns.length) {
      if (DEBUG) console.warn('[BB Popup][debugRewards] renderCards: state.campaigns=0 — showing "No coupons available right now"',
        '| state.loaded:', state.loaded, '| _fetchError:', _fetchError,
        '| cfg.loggedIn:', cfg.loggedIn, '| cfg.pageDataUrl:', cfg.pageDataUrl);
      cardsEl.innerHTML = '<p class="bb-cp-empty">No coupons available right now.</p>';
      return;
    }
    var now  = Date.now();
    var html = '';
    state.campaigns.forEach(function (c) {
      var claimed   = state.claimedIds.has(String(c.id));
      var used      = state.usedIds.has(String(c.id));
      var countdown = '';
      if (cfg.countdowns && c.expires_at) {
        var ms = new Date(c.expires_at).getTime() - now;
        if (ms > 0) countdown = '<span class="bb-cp-card-countdown">' + esc(formatCountdown(ms)) + '</span>';
      }
      var minHtml  = (c.minimum_order && c.minimum_order > 0)
        ? '<span class="bb-cp-card-min">Min. $' + esc(String(Number(c.minimum_order).toFixed(0))) + '</span>' : '';
      var codeHtml = c.code
        ? '<span class="bb-cp-card-code">' + esc(String(c.code)) + '</span>' : '';
      var typeLabel = '';
      if (cfg.showCouponTypeLabel !== false) {
        var applyType = c.applies_to && c.applies_to.type;
        if (applyType === 'products') {
          typeLabel = '<span class="bb-cp-card-type-label bb-cp-card-type-label--product">Product Discount</span>';
        } else if (applyType === 'collections') {
          typeLabel = '<span class="bb-cp-card-type-label bb-cp-card-type-label--collection">Collection Coupon</span>';
        } else {
          typeLabel = '<span class="bb-cp-card-type-label bb-cp-card-type-label--sitewide">Site-wide</span>';
        }
      }
      var badge;
      if (used) {
        badge = '<span class="bb-cp-badge bb-cp-badge--used">Used</span>';
      } else if (claimed) {
        badge = '<span class="bb-cp-badge bb-cp-badge--saved">Saved to Coupons</span>';
      } else {
        badge = '<span class="bb-cp-badge bb-cp-badge--available">Coupon Available</span>';
      }
      var cls = 'bb-cp-card';
      if (used)         cls += ' bb-cp-card--used';
      else if (claimed) cls += ' bb-cp-card--claimed';

      html += '<div class="' + cls + '" data-id="' + esc(String(c.id)) + '">';
      html +=   '<div class="bb-cp-card-left"><span class="bb-cp-card-value">' + esc(formatDiscount(c)) + '</span></div>';
      var lbl = cleanCouponDisplay(c);
      html +=   '<div class="bb-cp-card-body">';
      if (typeLabel) html += typeLabel;
      html +=     '<p class="bb-cp-card-title">'  + esc(lbl.title) + '</p>';
      if (lbl.subtitle)  html += '<p class="bb-cp-card-subtitle">' + esc(lbl.subtitle) + '</p>';
      if (lbl.refText)   html += '<p class="bb-cp-card-product-ref">' + esc(lbl.refText) + '</p>';
      if (lbl.linkLabel) html += '<a class="bb-cp-product-link" href="/products/' + esc(lbl.handle) + '">' + esc(lbl.linkLabel) + '</a>';
      html +=     '<div class="bb-cp-card-meta">' + codeHtml + minHtml + countdown + '</div>';
      html +=   '</div>';
      html +=   '<div class="bb-cp-card-right">'  + badge + '</div>';
      html += '</div>';
    });
    cardsEl.innerHTML = html;
  }

  /* ── Update CTA button state ── */
  function updateCollectBtn() {
    if (!collectBtn) return;
    if (!state.campaigns.length) {
      collectBtn.textContent = 'No coupons available.';
      collectBtn.disabled    = true;
      return;
    }
    var unclaimed = state.campaigns.filter(function (c) {
      return !state.claimedIds.has(String(c.id)) && !state.usedIds.has(String(c.id));
    });
    if (!unclaimed.length) {
      collectBtn.textContent = cfg.loggedIn
        ? 'Your coupons are already saved.'
        : (cfg.loggedOutBtn || 'Log In to Save Coupons');
      collectBtn.disabled = cfg.loggedIn;
      collectBtn.classList.toggle('bb-cp-btn--done', cfg.loggedIn);
      if (walletLink && cfg.loggedIn) walletLink.style.display = '';
      return;
    }
    collectBtn.classList.remove('bb-cp-btn--done');
    collectBtn.disabled    = false;
    collectBtn.textContent = cfg.loggedIn
      ? (cfg.collectBtnText || 'Collect All')
      : (cfg.loggedOutBtn   || 'Log In to Save Coupons');
  }

  /* ── Collect All handler ── */
  function handleCollect() {
    if (state.claiming) return;
    var unclaimed = state.campaigns.filter(function (c) {
      return !state.claimedIds.has(String(c.id)) && !state.usedIds.has(String(c.id));
    });
    if (!unclaimed.length) {
      if (cfg.toast) showToast('Your coupons are already saved.');
      return;
    }
    var ids = unclaimed.map(function (c) { return String(c.id); });

    /* Logged out: save intent, show toast, then redirect */
    if (!cfg.loggedIn) {
      try {
        localStorage.setItem(PENDING_KEY, JSON.stringify({
          campaign_ids: ids,
          source:       'coupon_popup_collect_all',
          created_at:   new Date().toISOString()
        }));
      } catch (e) {}
      if (cfg.toast) showToast('Log in to save these coupons.');
      setTimeout(function () { window.location.href = cfg.loginUrl || '/account/login'; }, 800);
      return;
    }

    /* Logged in: POST claim */
    state.claiming         = true;
    collectBtn.disabled    = true;
    collectBtn.textContent = 'Saving…';

    var slowTimer = setTimeout(function () {
      if (cfg.toast) showToast('Coupons are taking longer than usual.');
    }, 6000);

    fetch(cfg.claimUrl, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ campaign_ids: ids, source: 'coupon_popup_collect_all' })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        clearTimeout(slowTimer);
        state.claiming = false;
        if (d.ok || (d.claimed != null && d.claimed > 0)) {
          ids.forEach(function (id) { state.claimedIds.add(id); });
          updateHeading();
          renderCards();
          collectBtn.textContent = 'Coupons saved to your wallet.';
          collectBtn.disabled    = true;
          collectBtn.classList.add('bb-cp-btn--done');
          if (walletLink) walletLink.style.display = '';
          if (cfg.toast) showToast('Coupons saved to your wallet.');
          if (window.BBRewardNotifications) window.BBRewardNotifications.show('coupon_claimed', {});
        } else {
          collectBtn.disabled    = false;
          collectBtn.textContent = cfg.collectBtnText || 'Collect All';
        }
      })
      .catch(function () {
        clearTimeout(slowTimer);
        state.claiming         = false;
        collectBtn.disabled    = false;
        collectBtn.textContent = cfg.collectBtnText || 'Collect All';
      });
  }

  /* ── Pending post-login claim ── */
  function tryResolvePendingClaim() {
    var raw;
    try { raw = localStorage.getItem(PENDING_KEY); } catch (e) { return; }
    if (!raw) return;
    var pending;
    try { pending = JSON.parse(raw); } catch (e) {
      try { localStorage.removeItem(PENDING_KEY); } catch (e2) {}
      return;
    }
    if (!Array.isArray(pending.campaign_ids) || !pending.campaign_ids.length) {
      try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
      return;
    }
    /* Expire after 24 hours */
    if (pending.created_at && (Date.now() - new Date(pending.created_at).getTime()) > 86400000) {
      try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
      return;
    }
    fetch(cfg.claimUrl, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        campaign_ids: pending.campaign_ids,
        source:       pending.source || 'coupon_popup_collect_all'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
        if ((d.ok || (d.claimed != null && d.claimed > 0)) && cfg.toast) {
          showToast('Your coupons were saved.');
        }
      })
      .catch(function () { /* Keep key — retry next visit */ });
  }

  /* ── Show / dismiss ── */
  /* Page lock shared with the cart drawer and other overlays
     (bb-overlay-coordinator.js): closing the wallet over the open cart
     drawer leaves the page locked. */
  function pageLock() {
    if (window.BBOverlay) window.BBOverlay.lock('cart:coupons', overlay);
    else document.body.style.overflow = 'hidden';
  }

  function pageUnlock() {
    if (window.BBOverlay) window.BBOverlay.unlock('cart:coupons');
    else document.body.style.overflow = '';
  }

  function openOverlay() {
    if (!overlay) return;
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    pageLock();
    if (modal) setTimeout(function () { modal.focus(); }, 40);
  }

  function dismiss() {
    if (!overlay) return;
    autoOpened = false;
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    pageUnlock();
    try {
      localStorage.setItem(DISMISS_KEY, JSON.stringify({
        until: Date.now() + (cfg.dismissHours || 12) * 3600000
      }));
    } catch (e) {}
  }

  function dismissToday() {
    if (!overlay) return;
    autoOpened = false;
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    pageUnlock();
    try {
      var midnight = new Date();
      midnight.setHours(24, 0, 0, 0); /* next local midnight */
      localStorage.setItem(HIDE_TODAY_KEY, String(midnight.getTime()));
    } catch (e) {}
  }

  /* ── Toast ── */
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4000);
  }

  /* ── Formatters ── */
  function formatDiscount(c) {
    var v = c.value || 0;
    if (c.type === 'percentage')   return v + '% OFF';
    if (c.type === 'fixed_amount') return '$' + v + ' OFF';
    return v ? v + ' OFF' : 'Coupon';
  }

  function formatCountdown(ms) {
    if (ms <= 0) return 'Expired';
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000)  / 60000);
    if (d > 0) return 'Ends ' + d + 'd ' + h + 'h';
    if (h > 0) return 'Ends ' + h + 'h ' + m + 'm';
    return 'Ends ' + m + 'm';
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
